import React from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';

import CrossIcon from '../../../assets/cross-icon-new.svg';

import styles from '../../styles/views/components/Modal.module.scss';

const Modal = ({
  isShown, onClose, children, modalExtraClass, wrapperExtraStyles, closeIconExtraClass,
}) => ReactDOM.createPortal(
  isShown ? (
    <div className={styles.wrapper} style={wrapperExtraStyles}>
      <div className={`${styles.modal} ${modalExtraClass}`}>
        <i className={styles.closeIcon} onClick={onClose}>
          <CrossIcon className={closeIconExtraClass} />
        </i>
        {children}
      </div>
    </div>
  )
    : null,
  document.body,
);


Modal.propTypes = {
  isShown: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  wrapperExtraStyles: PropTypes.object,
  children: PropTypes.node.isRequired,
  modalExtraClass: PropTypes.string,
  closeIconExtraClass: PropTypes.string,
};


Modal.defaultProps = {
  modalExtraClass: '',
  wrapperExtraStyles: {},
  closeIconExtraClass: '',
};

export default Modal;
